import React, { useEffect, useState } from 'react';
import { useGetOrganizationContactsQuery } from '../../../api/organizations.js';
import ThreeDotsLoader from '../../misc/ThreeDotsLoader.jsx';
import { Link } from 'react-router-dom';
import OrganizationContactsCarousel from '../OrganizationContactsCarousel.jsx';

const OrganizationContacts = ({ orgId }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [allContacts, setAllContacts] = useState([]);
    const contactsPerPage = 10;

    const {
        data: contactsData,
        isLoading: contactsLoading,
        isFetching: contactsFetching
    } = useGetOrganizationContactsQuery({ page: currentPage, per_page: contactsPerPage, id: orgId });

    const hasMorePages = contactsData?.response?.has_more_pages || false;

    const mergeContacts = (newContacts) => {
        setAllContacts((prevContacts) => {
            const existingIds = new Set(prevContacts.map((contact) => contact.id));
            const filteredNewContacts = newContacts.filter((contacts) => !existingIds.has(contacts.id));
            return [...prevContacts, ...filteredNewContacts];
        });
    };

    useEffect(() => {
        if (contactsData?.response?.contacts) {
            mergeContacts(contactsData.response.contacts);
        }
    }, [contactsData]);

    const handleLoadMore = () => {
        if (hasMorePages) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    return (
        <>
            {allContacts.length !== 0 ? (
                <div className='mt-4 py-4 pl-6 pr-4 bg-theme1-primary2 rounded-4xl'>
                    <div className='flex justify-between'>
                        <div className='text-lg font-bold text-theme1-white'>Contacts</div>
                        {hasMorePages && (
                            <Link className='text-theme1-white' to={'/contacts/advanced-search?company=' + orgId}>
                                View All
                            </Link>
                        )}
                    </div>
                    {contactsLoading && currentPage === 1 ? (
                        <ThreeDotsLoader />
                    ) : (
                        <OrganizationContactsCarousel
                            items={allContacts || []}
                            className='indicators-white'
                            orgId={orgId}
                        />
                    )}
                </div>
            ) : null}
        </>
    );
};

export default OrganizationContacts;
